import { createContext } from 'react';
import type { IModuleStrings } from '@platform/core/types';

/** Рядки модуля для піддерева (список, запис, меню): листові компоненти беруть їх через useModuleStrings() без пропсів. */
export const ModuleStringsContext = createContext<IModuleStrings | null>(null);
